<button mat-button color="primary" *ngIf="canEdit" (click)="assignTasks()">
   <mat-icon>add</mat-icon>
   Assign Tasks
</button>
<app-table [config]="tableConfig" [filterBar]="filterBarConfig"></app-table>
